import { filtersAccordionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";
import { AccordionSectionHeader, AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import { CheckboxStyle } from "@insite/mobius/Checkbox";
import { CheckboxGroupStyle } from "@insite/mobius/CheckboxGroup";
import { colorPalette } from "@waytek/Utilities/variables";
import { css } from "styled-components";

filtersAccordionStyles.accordion = {
    ...filtersAccordionStyles.accordion,

    mergeCss: true,
    css: css`
        margin-top: 20px;

        ${AccordionSectionHeader} {
            button {
                padding: 9px 6px 9px 10px !important;
                margin-bottom: 1px;

                &:focus {
                    padding: 9px 6px 9px 10px !important;
                }

                &[aria-expanded="true"] {
                    margin-bottom: 0;
                }
            }
        }

        ${AccordionSectionPanel} {
            padding: 15px 10px;

            ${CheckboxGroupStyle} {
                & > legend:empty,
                & > span:empty {
                    display: none;
                }

                &:not(:last-child) {
                    padding-bottom: 10px;
                }

                ${CheckboxStyle} {
                    color: ${colorPalette.common.global.darkerGray};

                    > * {
                        margin-top: 0;
                        margin-bottom: 0;
                    }

                    label {
                        word-break: initial;
                    }
                }
            }
        }
    `,
};
